import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Check, X } from 'lucide-react';

// Tendina a selezione multipla per i filtri (calendario, clienti).
// opzioni: [valore, etichetta]; selezionati vuoto = tutti.
export const FiltroMulti: React.FC<{
    placeholder: string;
    opzioni: [string, string][];
    selezionati: string[];
    onChange: (v: string[]) => void;
}> = ({ placeholder, opzioni, selezionati, onChange }) => {
    const [open, setOpen] = useState(false);
    const [cerca, setCerca] = useState('');
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!open) return;
        const chiudi = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
        document.addEventListener('mousedown', chiudi);
        return () => document.removeEventListener('mousedown', chiudi);
    }, [open]);
    useEffect(() => { if (!open) setCerca(''); }, [open]);
    const q = cerca.trim().toLowerCase();
    const opzioniVisibili = q ? opzioni.filter(([, lbl]) => lbl.toLowerCase().includes(q)) : opzioni;
    const toggle = (v: string) => onChange(selezionati.includes(v) ? selezionati.filter(x => x !== v) : [...selezionati, v]);
    const attivo = selezionati.length > 0;
    const etichetta = !attivo ? placeholder
        : selezionati.length === 1 ? (opzioni.find(([v]) => v === selezionati[0])?.[1] ?? placeholder)
        : `${selezionati.length} selezionati`;
    return (
        <div ref={ref} className="relative w-full sm:w-auto">
            <button
                type="button"
                onClick={() => setOpen(o => !o)}
                className={`w-full sm:w-auto sm:min-w-[170px] sm:max-w-[240px] flex items-center justify-between gap-2 px-3 py-2 rounded-xl border text-xs font-semibold shadow-sm ${attivo ? 'bg-blue-50 border-blue-300 text-blue-800' : 'bg-white border-gray-300 text-gray-700'}`}
            >
                <span className="truncate">{etichetta}</span>
                <ChevronDown size={14} className="shrink-0 opacity-70"/>
            </button>
            {open && (
                <div className="absolute z-30 mt-1 w-full sm:w-64 bg-white border border-gray-200 rounded-xl shadow-lg">
                    <div className="p-2 border-b border-gray-100">
                        <input
                            autoFocus
                            value={cerca}
                            onChange={e => setCerca(e.target.value)}
                            placeholder="Cerca..."
                            className="w-full px-2.5 py-1.5 rounded-lg border border-gray-200 text-xs focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-300"
                        />
                    </div>
                    <div className="max-h-72 overflow-y-auto py-1">
                        {opzioniVisibili.length === 0 && (
                            <p className="px-3 py-2 text-xs text-gray-400 italic">{q ? 'Nessun risultato.' : 'Nessuna voce nel periodo.'}</p>
                        )}
                        {opzioniVisibili.map(([v, lbl]) => {
                            const on = selezionati.includes(v);
                            return (
                                <button key={v} type="button" onClick={() => toggle(v)}
                                    className={`w-full flex items-center gap-2 px-3 py-1.5 text-left text-xs hover:bg-gray-50 ${on ? 'font-bold text-blue-800' : 'text-gray-700'}`}>
                                    <span className={`w-4 h-4 shrink-0 rounded border flex items-center justify-center ${on ? 'bg-blue-600 border-blue-600 text-white' : 'border-gray-300 bg-white'}`}>
                                        {on && <Check size={11} strokeWidth={3}/>}
                                    </span>
                                    <span className="truncate">{lbl}</span>
                                </button>
                            );
                        })}
                    </div>
                    {attivo && (
                        <button type="button" onClick={() => onChange([])}
                            className="w-full flex items-center gap-1 px-3 py-2 border-t border-gray-100 text-xs font-bold text-blue-600 hover:bg-blue-50 rounded-b-xl">
                            <X size={12}/> Deseleziona tutti
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};
